
import { motion } from "framer-motion";
import { CheckCheck, Star, Award, Trophy } from "lucide-react";

interface QuizScoreMessageProps {
  score: number;
  totalQuestions: number;
}

const QuizScoreMessage = ({ score, totalQuestions }: QuizScoreMessageProps) => {
  // Determine which badge to show based on score
  const getBadgeIcon = () => {
    if (score <= 2) {
      return <Star className="w-12 h-12 text-corporate-secondary-75" />;
    } else if (score <= 4) {
      return <Award className="w-12 h-12 text-corporate-secondary-75" />;
    } else {
      return <Trophy className="w-12 h-12 text-corporate-secondary-100" />;
    }
  };

  // Determine message based on score
  const getMessage = () => {
    if (score <= 2) {
      return "Good start! Keep learning to improve your trading knowledge.";
    } else if (score <= 4) {
      return "Well done! You have a solid understanding of the basics.";
    } else {
      return "Excellent! You've mastered the fundamentals of trading.";
    }
  };

  return (
    <motion.div
      initial={{ y: 20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ delay: 0.5, duration: 0.5 }}
      className="text-center"
    >
      <h2 className="text-3xl font-bold text-corporate-primary-100 mb-2">
        Congratulations!
      </h2>
      
      <div className="flex items-center justify-center gap-2 mb-3">
        <CheckCheck className="w-5 h-5 text-corporate-primary-75" />
        <p className="text-xl font-medium">
          Quiz Complete
        </p>
      </div>

      <div className="flex justify-center mb-4">
        {getBadgeIcon()}
      </div>
      
      <p className="text-xl mb-3 font-medium">
        You scored <span className="text-corporate-primary-75 font-bold">{score}</span> out of <span className="text-corporate-primary-75 font-bold">{totalQuestions}</span>
      </p>

      <p className="text-lg text-corporate-neutral-75 mb-6">
        {getMessage()}
      </p>
    </motion.div>
  );
};

export default QuizScoreMessage;
